import { AuditLogDto, ConfigClient, EmailSettingsModel } from '@app/api2/api';
import SemanticField from '@app/components/SemanticField';
import * as React from 'react';
import { Button, Container, Form, FormCheckbox, Grid, GridColumn, GridRow, Header, Icon, Segment, Table, TableHeader, TableHeaderCell, TableRow } from 'semantic-ui-react';
import { BPForm } from '@common/BPForm';
import { PageHeader } from '@common/PageHeader';
import { BPColumn } from '@common/BPReactTable';
import { AppSettingsSchema } from './AppSettings.Schema';
import SemanticFormikTextArea from '@common/Forms/SemanticFormikTextArea';
import SemanticFormikInput from '@common/Forms/SemanticFormikInput';
import { BPDataTable3 } from '../Common/DataTable/BPDataTable3';
import { BPButton } from '@/components/bp/bpbutton';
import { BPContainer } from '@/components/bp/bpcontainer';
import { Tab } from '@/components/bp/bp-ui';
import { useTranslation2 } from '../Contexts/TranslationContext2';
import { useFormikContext } from 'formik';

const client = new ConfigClient()

interface IAppSettingsProps {
}

export const AppSettings: React.FunctionComponent<IAppSettingsProps> = (props) => {

    const [settings, setSettings] = React.useState<EmailSettingsModel>()



    React.useEffect(() => {
        async function fetch() {
            const res = await client.getEmailSettings()
            setSettings(res);
            // console.log(res)
        }

        fetch()
    }, [])


    const handleKitCheckChange = (e, args) => {
        const runTypes = [...settings.runTypes];
        runTypes[args.index].isEnabled = args.checked;
        setSettings({ ...settings, runTypes: runTypes })

    };


    const handleLocaleCheckChange = (e, args) => {
        const locales = [...settings.locales];
        locales[args.index].isEnabled = args.checked;
        setSettings({ ...settings, locales: locales })

    };

    const providers = [{ name: 'SMTP', value: 'Smtp' }, { name: 'SendGrid', value: 'SendGrid' }, { name: 'GraphApi', value: 'GraphApi' }, { name: 'AzureEmailComm', value: 'AzureEmailComm' }].map(x => {
        return { key: `form${x.value}`, value: x.value, text: x.name }
    })

    const t = window.translation;

    return <>
        <BPContainer>
            <BPForm
                hideButtons={true}
                initialValues={settings}
                vaildationSchema={AppSettingsSchema}
                onSubmit={async (values) => {
                    // console.log(values)
                    await client.setEmailSettings(values)
                }}>
                {(fProps) => {
                    return <>
                        <PageHeader header={t.common.appSettings} renderRight={() => <>
                            <BPButton type="submit" disabled={fProps.isSubmitting}>{t.common.save}</BPButton>

                            {/* <BPButton submit primary icon={'save'} title={t.common.save} as={'a'} ></BPButton> */}
                        </>} />

                        <Tab
                            menu={{ pointing: false, vertical: true, tabular: true }}
                            panes={[{
                                menuItem: 'General',
                                render: () => <GeneralSettings settings={settings} setSettings={setSettings} />,
                            }, {
                                menuItem: t.appSettings.emailSettings,
                                render: () => <EmailSettings />,
                            }, {
                                menuItem: t.common.languages,
                                render: () => <Languages settings={settings} setSettings={setSettings} />,
                            }, {
                                menuItem: 'OpenAI',
                                render: () => <OpenAISettings settings={settings} setSettings={setSettings} />,
                            }, {
                                menuItem: t.common.runTypePlural,
                                render: () => <CaseRunAndSearchSettings settings={settings} setSettings={setSettings} />,
                            }, {
                                menuItem: 'Batch',
                                render: () => <BatchSettings settings={settings} setSettings={setSettings} />,
                            }
                            ]}>

                        </Tab>


                        {/* <EmailSettings /> */}
                        {/* <Header size={'medium'}>{t.appSettings.emailSettings}</Header>

                        <Grid columns={'equal'}>
                            <GridRow>
                                <GridColumn>
                                    <SemanticField
                                        name="fromEmail"
                                        component={Form.Input}
                                        label={t.appSettings.emailFromEmail}
                                        width={16} />
                                    <SemanticField
                                        name="fromName"
                                        component={Form.Input}
                                        label={t.appSettings.emailFromName}
                                        width={16} />

                                </GridColumn>
                                <GridColumn>
                                    <SemanticField
                                        name="emailProvider"
                                        label={t.appSettings.emailProvider}
                                        component={Form.Dropdown}
                                        selection options={providers}
                                        value={fProps.values?.emailProvider}
                                        width={16}
                                        error={fProps.errors.emailProvider && fProps.touched.emailProvider} />

                                    {fProps.values?.emailProvider == 'SendGrid' &&

                                        <SemanticField
                                            name="sendGridApiKey"
                                            component={Form.Input}
                                            label={t.appSettings.emailSendGridApiKey}
                                            width={16} />
                                    }

                                    {fProps.values?.emailProvider == 'AzureEmailComm' &&

                                        <SemanticField
                                            name="azureCommServiceEndpoint"
                                            component={Form.Input}
                                            label={'Endpoint URL'}
                                            width={16} />
                                    }

                                    {fProps.values?.emailProvider == 'Smtp' && <>
                                        <SemanticField
                                            name="host"
                                            component={Form.Input}
                                            label={t.appSettings.emailSmtpHost}
                                            width={16} />

                                        <SemanticField
                                            name="port"
                                            component={Form.Input}
                                            label={t.appSettings.emailSmtpPort}
                                            width={16} />

                                        <SemanticField
                                            name="username"
                                            component={Form.Input}
                                            label={t.appSettings.emailSmtpUsername}
                                            width={16}
                                            autoComplete='new-password' />

                                        <SemanticField
                                            name="password"
                                            component={Form.Input}
                                            label={t.appSettings.emailSmtpPassword}
                                            width={16}
                                            type="password"
                                            autoComplete='new-password' />
                                    </>
                                    }


                                    <SemanticField
                                        name="testEmail"
                                        component={Form.Input}
                                        label={t.appSettings.emailSendTestEmail}
                                        iconPosition={'left'}
                                        width={16}
                                        type="email"
                                        action>
                                        <Icon name="at" />
                                        <input />
                                        <BPButton icon={'send'} title={t.appSettings.emailSendTestEmail} as={'a'} onClick={async (ev) => {
                                            ev.preventDefault();
                                            ev.stopPropagation();

                                            await client.sendTestMessage(fProps.values, (fProps.values as any).testEmail)
                                        }}></BPButton>
                                    </SemanticField>
                                </GridColumn>
                            </GridRow>
                        </Grid> */}

                        {/* <Header size={'medium'}>{'OpenAI Settings'}</Header>
                        <Grid columns={2}>
                            <GridColumn>
                                <SemanticFormikInput
                                    name="openAiApiKey"
                                    label={'OpenAI API Key'}
                                    width={8} />
                                <SemanticFormikInput
                                    name="openAiModel"
                                    label={'OpenAI Model'}
                                    width={8} />
                            </GridColumn>
                            <GridColumn>
                                <SemanticFormikTextArea
                                    name="openAiEpgPrompt"
                                    label={'OpenAI EPG Prompt'}
                                    rows={8}
                                    width={8} />
                            </GridColumn>
                        </Grid> */}
                        {/* <CaseRunAndSearchSettings settings={settings} setSettings={setSettings} /> */}
                        {/* <OpenAISettings settings={settings} setSettings={setSettings} /> */}
                        {/* <Header size={'medium'}>{t.common.language}</Header>
                        <Grid columns={4}>
                            {settings?.locales?.map((locale, i) => {
                                return <GridColumn key={locale.code}><FormCheckbox label={locale.localizedName} checked={locale.isEnabled}
                                    onChange={(e, a) => handleLocaleCheckChange(e, {
                                        ...a,
                                        locale: locale,
                                        index: i
                                    })} /></GridColumn>

                            })}


                        </Grid> */}
                        {/* <Languages settings={settings} setSettings={setSettings} /> */}





                    </>
                }}
            </BPForm>

            {/* <AuditSegment /> */}
            {/* <TestForm />

            <Roles /> */}

        </BPContainer>
    </>;
};

function CaseRunAndSearchSettings({ settings, setSettings }) {
    const { translations: t } = useTranslation2();
    const fProps = useFormikContext<EmailSettingsModel>();

    const handleKitCheckChange = (e, args) => {
        const runTypes = [...settings.runTypes];
        runTypes[args.index].isEnabled = args.checked;
        setSettings({ ...settings, runTypes: runTypes })

    };
    const providers = [{ name: 'SMTP', value: 'Smtp' }, { name: 'SendGrid', value: 'SendGrid' }, { name: 'GraphApi', value: 'GraphApi' }, { name: 'AzureEmailComm', value: 'AzureEmailComm' }].map(x => {
        return { key: `form${x.value}`, value: x.value, text: x.name }
    })

    return <>

        <Header size={'medium'}>{t.common.runTypePlural}</Header>
        <Grid columns={4}>
            {settings?.runTypes?.map((rt, i) => {
                return <GridColumn key={rt.runTypeId}><FormCheckbox label={window.translation.runType[rt.runType]} checked={rt.isEnabled}
                    onChange={(e, a) => handleKitCheckChange(e, {
                        ...a,
                        kit: rt,
                        index: i
                    })} /></GridColumn>

            })}
        </Grid>


    </>;
}

function GeneralSettings({ settings, setSettings }) {
    const { translations: t } = useTranslation2();

    return <>
        <Header size={'medium'}>{t.dataTable.search}</Header>

        <Grid columns={4}>
            <GridColumn>
                <SemanticField
                    name="searchInAllLabs"
                    component={Form.Checkbox}
                    label={'Search in All Labs'} />
            </GridColumn>
            {/* <GridColumn>
                                <SemanticField
                                    name="allowSamplesFromOtherCases"
                                    component={Form.Checkbox}
                                    label={'Allow samples from other cases'} />
                            </GridColumn> */}
            <GridColumn>
                <SemanticField
                    name="secondaryParametersCollapsed"
                    component={Form.Checkbox}
                    label={'Secondary parameters collapsed'} />
            </GridColumn>

        </Grid>
        <Grid columns={2}>
            <GridColumn>
                <Header size={'medium'}>{t.common.populations}</Header>
                <SemanticField
                    name="populationFrequencyMaxError"
                    component={Form.Input}
                    label={t.appSettings.populationFrequencyMaxError}
                    width={8} />

            </GridColumn>
            <GridColumn>
                <Header size={'medium'}>{t.appSettings.generalSettings}</Header>
                <SemanticField
                    name="requestAccessUrl"
                    component={Form.Input}
                    label={t.appSettings.requestAccessUrl}
                    width={8} />

            </GridColumn>
        </Grid>

    </>;
}

function BatchSettings({ settings, setSettings }) {

    return <>
        <Header size={'medium'}>{'Batch settings'}</Header>
        <Grid>
            <GridColumn>
                <SemanticFormikTextArea
                    name="autoscaleFormula"
                    label={'Autoscale Formula'}
                    rows={25}
                    autoComplete='off'
                    width={8} />
            </GridColumn>
        </Grid>
    </>;
}

function OpenAISettings({ settings, setSettings }) {
    const { translations: t } = useTranslation2();
    const fProps = useFormikContext<EmailSettingsModel>();


    const providers = [{ name: 'SMTP', value: 'Smtp' }, { name: 'SendGrid', value: 'SendGrid' }, { name: 'GraphApi', value: 'GraphApi' }, { name: 'AzureEmailComm', value: 'AzureEmailComm' }].map(x => {
        return { key: `form${x.value}`, value: x.value, text: x.name }
    })

    return <>
        <Header size={'medium'}>{'OpenAI Settings'}</Header>
        <Grid columns={2}>
            <GridColumn>
                <SemanticFormikInput
                    name="openAiApiKey"
                    label={'OpenAI API Key'}
                    width={8} />
                <SemanticFormikInput
                    name="openAiModel"
                    label={'OpenAI Model'}
                    width={8} />
            </GridColumn>
            <GridColumn>
                <SemanticFormikTextArea
                    name="openAiEpgPrompt"
                    label={'OpenAI EPG Prompt'}
                    rows={8}
                    width={8} />
            </GridColumn>
        </Grid>

    </>;
}

function Languages({ settings, setSettings }) {
    const { translations: t } = useTranslation2();
    const fProps = useFormikContext<EmailSettingsModel>();
    const handleLocaleCheckChange = (e, args) => {
        const locales = [...settings.locales];
        locales[args.index].isEnabled = args.checked;
        setSettings({ ...settings, locales: locales })

    };


    const providers = [{ name: 'SMTP', value: 'Smtp' }, { name: 'SendGrid', value: 'SendGrid' }, { name: 'GraphApi', value: 'GraphApi' }, { name: 'AzureEmailComm', value: 'AzureEmailComm' }].map(x => {
        return { key: `form${x.value}`, value: x.value, text: x.name }
    })

    return <>
        <Header size={'medium'}>{t.common.language}</Header>
        <Grid columns={4}>
            {settings?.locales?.map((locale, i) => {
                return <GridColumn key={locale.code}><FormCheckbox label={locale.localizedName} checked={locale.isEnabled}
                    onChange={(e, a) => handleLocaleCheckChange(e, {
                        ...a,
                        locale: locale,
                        index: i
                    })} /></GridColumn>

            })}


        </Grid>
    </>;
}


function EmailSettings() {
    const { translations: t } = useTranslation2();
    const fProps = useFormikContext<EmailSettingsModel>();

    const providers = [{ name: 'SMTP', value: 'Smtp' }, { name: 'SendGrid', value: 'SendGrid' }, { name: 'GraphApi', value: 'GraphApi' }, { name: 'AzureEmailComm', value: 'AzureEmailComm' }].map(x => {
        return { key: `form${x.value}`, value: x.value, text: x.name }
    })

    return <>
        <Header size={'medium'}>{t.appSettings.emailSettings}</Header>

        <Grid columns={'equal'}>
            <GridRow>
                <GridColumn>
                    <SemanticField
                        name="fromEmail"
                        component={Form.Input}
                        label={t.appSettings.emailFromEmail}
                        width={16} />
                    <SemanticField
                        name="fromName"
                        component={Form.Input}
                        label={t.appSettings.emailFromName}
                        width={16} />

                </GridColumn>
                <GridColumn>
                    <SemanticField
                        name="emailProvider"
                        label={t.appSettings.emailProvider}
                        component={Form.Dropdown}
                        selection options={providers}
                        value={fProps.values?.emailProvider}
                        width={16}
                        error={fProps.errors.emailProvider && fProps.touched.emailProvider} />

                    {fProps.values?.emailProvider == 'SendGrid' &&

                        <SemanticField
                            name="sendGridApiKey"
                            component={Form.Input}
                            label={t.appSettings.emailSendGridApiKey}
                            width={16} />
                    }

                    {fProps.values?.emailProvider == 'AzureEmailComm' &&

                        <SemanticField
                            name="azureCommServiceEndpoint"
                            component={Form.Input}
                            label={'Endpoint URL'}
                            width={16} />
                    }

                    {fProps.values?.emailProvider == 'Smtp' && <>
                        <SemanticField
                            name="host"
                            component={Form.Input}
                            label={t.appSettings.emailSmtpHost}
                            width={16} />

                        <SemanticField
                            name="port"
                            component={Form.Input}
                            label={t.appSettings.emailSmtpPort}
                            width={16} />

                        <SemanticField
                            name="username"
                            component={Form.Input}
                            label={t.appSettings.emailSmtpUsername}
                            width={16}
                            autoComplete='new-password' />

                        <SemanticField
                            name="password"
                            component={Form.Input}
                            label={t.appSettings.emailSmtpPassword}
                            width={16}
                            type="password"
                            autoComplete='new-password' />
                    </>
                    }


                    <SemanticField
                        name="testEmail"
                        component={Form.Input}
                        label={t.appSettings.emailSendTestEmail}
                        iconPosition={'left'}
                        width={16}
                        type="email"
                        action>
                        <Icon name="at" />
                        <input />
                        <BPButton icon={'send'} title={t.appSettings.emailSendTestEmail} as={'a'} onClick={async (ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();

                            await client.sendTestMessage(fProps.values, (fProps.values as any).testEmail)
                        }}></BPButton>
                    </SemanticField>
                </GridColumn>
            </GridRow>
        </Grid>
    </>;
}

function AuditSegment() {

    return <Segment>
        <Header size={'medium'}>{'Audit Logs'}</Header>

        <BPDataTable3
            defaultSortField='auditTime'
            defaultSortAsc={false}
            dataSource={async (props) => await client.getAuditLogs(props.perPage, props.page, props.sortBy, props.sortDirection, '')}
            columns={[
                { Header: 'Action', accessor: 'action' },
                { Header: 'Entity', accessor: 'entityName' },
                // { Header: 'Entity Pk', accessor: 'entityPk' },
                { Header: 'Username', accessor: 'username' },
                { Header: 'Time', accessor: 'auditTime' },
                // { Header: 'Changes', accessor: 'changes' },
                // { Header: 'Column Values', accessor: 'columnValues' },
            ] as BPColumn<AuditLogDto>[]}
            expandableRowsComponent={(row) => <Grid>
                <GridRow columns={2}>
                    <GridColumn>

                        {row.columnValues && <Table definition>
                            <TableHeader>
                                <TableRow>
                                    <TableHeaderCell width={10}>Field</TableHeaderCell>
                                    <TableHeaderCell>Value</TableHeaderCell>
                                </TableRow>
                            </TableHeader>
                            <Table.Body>
                                {Object.entries(row.columnValues ?? {}).map(([key, value]) => (
                                    <Table.Row key={key}>
                                        <Table.Cell width={10}>{key}</Table.Cell>
                                        <Table.Cell>{value}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>}
                    </GridColumn>
                    <GridColumn>
                        {row.changes && <Table definition>
                            <TableHeader>
                                <TableRow>
                                    <TableHeaderCell width={10}>Field</TableHeaderCell>
                                    <TableHeaderCell>Original Value</TableHeaderCell>
                                    <TableHeaderCell>New Value</TableHeaderCell>
                                </TableRow>
                            </TableHeader>
                            <Table.Body>
                                {Object.entries(row.changes ?? {}).map(([key, value]) => (
                                    <Table.Row key={key}>
                                        <Table.Cell width={10}>{key}</Table.Cell>
                                        <Table.Cell>{value['OriginalValue']}</Table.Cell>
                                        <Table.Cell>{value['NewValue']}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>}

                    </GridColumn>

                </GridRow>
            </Grid>} />
    </Segment>;
}

// export function TestForm() {
//     const countries = useCountryOptions({ defaultValue: 23 });
//     const states = useStateOptions({ countryId: countries.selectedId }, [countries.selectedId]);
//     return (
//         <Segment>
//             <Formik initialValues={{}} onSubmit={async (values) => {
//                 console.log(values);
//             }}>
//                 {({ handleSubmit, errors, values }) => (
//                     <Form onSubmit={handleSubmit}>
//                         <SemanticFormikSelect
//                             name="countryId"
//                             label="Country"
//                             {...countries.getDropdownProps()}
//                             placeholder="Select Country"
//                         />
//                         <SemanticFormikSelect
//                             name="stateId"
//                             label="State"
//                             {...states.getDropdownProps()}
//                             placeholder="Select State"
//                         />
//                         <BPButton type="submit">Submit</BPButton>

//                         <Grid>
//                             <GridRow columns={4}>
//                                 <GridColumn>
//                                     <div>{errors && <textarea value={JSON.stringify(errors, null, 2)} readOnly />}</div>
//                                 </GridColumn>
//                                 <GridColumn>
//                                     <div>{values && <textarea value={JSON.stringify(values, null, 2)} readOnly />}</div>
//                                 </GridColumn>
//                                 <GridColumn>
//                                     <div>{countries && <textarea value={JSON.stringify(countries, null, 2)} readOnly />}</div>
//                                 </GridColumn>
//                                 <GridColumn>
//                                     <div>{states && <textarea value={JSON.stringify(states, null, 2)} readOnly />}</div>
//                                 </GridColumn>

//                             </GridRow>
//                         </Grid>
//                     </Form>


//                 )}
//             </Formik>
//         </Segment>

//     );

// }

